(function () {
  var SELECTOR =
    '.btbtbtn:not(.qty-btn):not(.less):not(.more),' +
    '.product__add-to-cart,' +
    '.add-to-cart-btn,' +
    '.tb-pcard__cta-row--link,' +
    '.col-add-btn,' +
    '.tb-mc__checkout,' +
    '.cta-button,' +
    '.hero-button';

  function wrapButtonText(btn) {
    if (!btn || btn.dataset.tbBtnWrapped === 'true') return;
    if (btn.querySelector('.tb-btn__text')) {
      btn.dataset.tbBtnWrapped = 'true';
      return;
    }

    var textNodes = [];
    for (var i = 0; i < btn.childNodes.length; i++) {
      var node = btn.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        textNodes.push(node);
      }
    }

    if (!textNodes.length) return;

    textNodes.forEach(function (node) {
      var span = document.createElement('span');
      span.className = 'tb-btn__text';
      span.textContent = node.textContent.trim();
      btn.replaceChild(span, node);
    });

    btn.dataset.tbBtnWrapped = 'true';
  }

  function wrapAll(root) {
    root = root || document;
    root.querySelectorAll(SELECTOR).forEach(wrapButtonText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      wrapAll();
    });
  } else {
    wrapAll();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches && node.matches(SELECTOR)) wrapButtonText(node);
        wrapAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
